var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdvantages3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.214844 17.9695C0.0859375 19.0008 0 20.0492 0 21.1148C0 30.482 5.13047 38.6375 12.7273 42.9602L14.1453 39.9695V19.5422L12.5727 17.9695H0.214844ZM44 19.5422C44 17.9695 42.4273 16.3969 40.8547 16.3969H28.282C29.0641 13.2516 29.8547 10.1148 29.8547 8.54219C29.8547 5.39688 28.282 2.26016 27.5 1.46953C27.4828 1.45234 26.718 0.6875 25.1453 0.6875C22.7906 0.6875 22.7906 3.04219 22.7906 3.04219C22.7906 3.08516 22.0086 6.96953 22.0086 8.54219C22.0086 10.1148 18.8633 16.3969 17.2906 17.9695L15.718 18.7516V40.7516L17.2906 41.5336H34.5727C37.718 41.5336 39.2906 39.9609 39.2906 38.3883C39.2906 36.8156 37.718 35.243 36.1453 35.243C39.2906 35.243 40.8633 33.6703 40.8633 32.0977C40.8633 30.525 39.2906 28.9523 37.718 28.9523C40.8633 28.9523 42.4359 27.3797 42.4359 25.807C42.4359 24.2344 40.8633 22.6617 39.2906 22.6617C42.4273 22.6875 44 21.1148 44 19.5422Z",
    fill: "#3B8BEC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdvantages3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/advantages3.cd6a6fa692e419ac52dfa4e62246c65a.svg";